<div class="any-feed-dialog" [class.wizard-mode]="wizardMode">
    <!-- Header (only shown in dialog mode) -->
    @if (!wizardMode) {
        <div class="section-header" mat-dialog-title>
            <mat-icon class="section-icon">rss_feed</mat-icon>
            <span class="section-title">{{ 'ai.getAnyFeed' | transloco }}</span>
            <button mat-icon-button class="close-button" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    }
    <div [attr.mat-dialog-content]="!wizardMode ? '' : null" class="dialog-content">
        @if (!showResults) {
            <!-- Language Selector -->
            <div class="language-selector">
                <mat-icon class="language-icon">translate</mat-icon>
                <span class="language-label">{{ 'ai.language' | transloco }}:</span>
                <button mat-button class="language-button" (click)="openLanguageSelector()">
                    <span>{{ selectedLanguageName }}</span>
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
            </div>
            <div class="input-container">
                <textarea
                    #questionInput
                    class="question-textarea"
                    [(ngModel)]="userQuestion"
                    (focus)="onInputFocus($event)"
                    (blur)="onInputBlur()"
                    [placeholder]="'ai.typeYourQuestion' | transloco"
                    [disabled]="isLoading"
                    rows="4"></textarea>
                @if (!isInputFocused && !userQuestion && !isLoading) {
                    <div class="sample-questions">
                        <div class="sample-question" [@fadeInOut]="fadeState">
                            {{ currentSampleQuestion }}
                        </div>
                    </div>
                }

                @if (isLoading) {
                    <div class="loading-overlay">
                        <mat-spinner diameter="50"></mat-spinner>
                        <div class="loading-text">{{ 'ai.buildingFeed' | transloco }}...</div>
                    </div>
                }
            </div>

            <div class="hint-text">
                {{ 'ai.askAnything' | transloco }}
            </div>

            @if (errorMessage) {
                <div class="error-message">
                    <mat-icon>error</mat-icon>
                    {{ errorMessage }}
                </div>
            }
        }

        @if (showResults) {
            <div class="results-container">
                <div class="results-header">
                    <mat-icon>check_circle</mat-icon>
                    <span>{{ feedResults.length }} {{ 'ai.resultsFound' | transloco }}</span>
                </div>

                <div class="results-list">
                    @for (result of feedResults; track result.number) {
                        <div class="result-item">
                            <div class="result-number">{{ result.number }}</div>
                            <div class="result-content">
                                <div class="result-title">{{ result.title }}</div>
                                <div class="result-description">{{ result.description }}</div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>

    <!-- Actions (conditionally use mat-dialog-actions in dialog mode) -->
    <div [attr.mat-dialog-actions]="!wizardMode ? '' : null" class="dialog-actions">
        @if (!showResults) {
            <button mat-button (click)="onCancel()" [disabled]="isLoading">
                {{ 'ai.cancel' | transloco }}
            </button>
            <button
                mat-raised-button
                color="warn"
                [disabled]="!userQuestion || userQuestion.trim().length === 0 || isLoading"
                (click)="onSubmit()">
                @if (isLoading) {
                    <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
                    <span style="position: relative; top: -4px">{{('ai.loading' | transloco)}}</span>
                } @else {
                    <mat-icon>send</mat-icon>
                    <span style="position: relative; top: -7px; left: 5px">{{('ai.createFeed' | transloco) }}</span>
                }
            </button>
        }
        @if (showResults) {
            <button mat-button (click)="onNewSearch()">
                <mat-icon>refresh</mat-icon>
                {{ 'ai.newSearch' | transloco }}
            </button>
            <button mat-raised-button color="accent" (click)="onApplyFeed()">
                @if (wizardMode) {
                    <mat-icon>arrow_forward</mat-icon>
                    {{ 'general.next' | transloco }}
                } @else {
                    <mat-icon style="position: relative; left: -6px; top: 6px">check_circle</mat-icon>
                    <span>{{ 'ai.applyFeed' | transloco }}</span>
                }
            </button>
        }
    </div>
</div>
